/**
 * Created by Alican Köker on 2018-06-29.
 */

import {
    BetLineWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {Timeline, TimelineLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsInitialWPView} from "../initial/FruitsInitialWPView";
import {FruitsIndividiualWPBetlineView} from "./FruitsIndividiualWPBetlineView";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {
    IIndividualWinPresentationConfig
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";

export class FruitsIndividualWPController extends BetLineWinIndividualWPController {

    private _lineCounter:number = 0;
    private _lastWinData:IBetLineWinData;
    private _lineView:FruitsIndividiualWPBetlineView;

    private _belowStakeWinRestriction:boolean;

    public static readonly INDIVIDUAL_WIN_ACTIVE:string = "fruitsIndividualWPController_individualWinActive";

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);

        this._lineView = new FruitsIndividiualWPBetlineView();
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {
        if(super.parseFeatureGameData) {
            super.parseFeatureGameData(data);
        }
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue(data.totalWin, data.playedBetValue);
    }

    protected getLineAnimation(betLineWinData:IBetLineWinData):Timeline {
        EventHandler.dispatchEvent(new GameEvent(FruitsInitialWPView.HIDE_LINES));
        EventHandler.dispatchEvent(new GameEvent(FruitsIndividualWPController.INDIVIDUAL_WIN_ACTIVE));

        const timeline:TimelineLite = new TimelineLite();
        if(this._belowStakeWinRestriction) {
            timeline.add(() => {}, 0.5);
            return timeline;
        }

        //change the state of the symbols from previous betLine animation
        for(let i:number = 0; i < 6; i++) {
            let prevDataReelIndex:number = 0;
            if(this._lastWinData) {
                prevDataReelIndex = i < 2 ? i * 2 + this._lastWinData.betLine[i] - 1 : (i - 2) * 3 + this._lastWinData.betLine[i] + 4;
                let prevSym = Reels.getSymbol(prevDataReelIndex, 0);
                if(prevSym) {
                    prevSym.changeState({
                        state : FruitsGameConfig.instance.SYMBOL_STATES.normal,
                        fadeInDuration : 0,
                        setStack : false
                    });

                }
            }
        }

        const activeReels = this.parseActiveReels(betLineWinData);

        const winTl:TimelineLite = new TimelineLite();
        const normalTl:TimelineLite = new TimelineLite();
        activeReels.forEach(index => {
            const symbol = Reels.getSymbol(index, 0);
            if(symbol) {
                winTl.add(symbol.changeState({
                    state : FruitsGameConfig.instance.SYMBOL_STATES.win,
                    fadeInDuration : 0,
                    replay : false,
                }), 0);
                normalTl.add(symbol.changeState({
                    state : FruitsGameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration : 0.4,
                    replay : false,
                }), 0);
            }
        });

        timeline.add([
            () => FruitsIndividualWPController.dimDownPassiveSymbols(activeReels),
            this._lineView.animateWinningLine(<IBetLineWinData>(this._betWinsData![this._lineCounter]), this._lineCounter),
            winTl
        ]);
        timeline.add([
            normalTl,
            this._lineView.fadeOutLines()
        ], "+=0.6");

        this._lineCounter++;
        if(this._lineCounter === this._betWinsData!.length)
            this._lineCounter = 0;

        this._lastWinData = betLineWinData;
        return timeline;
    }

    private parseActiveReels(betlineData:IBetLineWinData):number[] {
        let activeReelIds:number[] = [];
        for(let i:number = 0; i < betlineData.nrOfSymbols; i++) {
            let reelId:number = i < 2 ? i * 2 + betlineData.betLine[i] - 1 : (i - 2) * 3 + betlineData.betLine[i] + 4;
            activeReelIds.push(reelId);
        }

        return activeReelIds;
    }

    private static dimDownPassiveSymbols(activeReelIds:number[]):void {
        for(let i:number = 0; i < FruitsGameConfig.instance.REELS_NUM; i++) {
            let sym = Reels.getSymbol(i, 0);
            if(FruitsIndividualWPController.isActive(i, activeReelIds)) {
                sym!.alpha = 1;
            } else {
                sym!.alpha = 0.5;
            }
        }
    }

    private static isActive(reelIdToCheck:number, activeReels:number[]):boolean {
        return activeReels.indexOf(reelIdToCheck) > -1;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._lineCounter = 0;
        this._lineView.initContainer();

        if(this._currentLineAnimation) {
            if(this._currentLineAnimation.isActive()) {
                this._currentLineAnimation.pause();
                this._currentLineAnimation.kill();
            }
            this._currentLineAnimation = null;
        }
        this._currentIndex = -1;
        this.resetWinSymbols(true);
    }
}